module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page"
  }, [_c('mu-refresh-control', {
    attrs: {
      "refreshing": _vm.refreshing,
      "trigger": _vm.trigger
    },
    on: {
      "refresh": _vm.refresh
    }
  }), _vm._v(" "), _c('pageTitle', {
    attrs: {
      "title": "常住人员管理",
      "showRight": true,
      "rightTitle": "新增"
    },
    on: {
      "rightHandler": _vm.open
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "plist"
  }, _vm._l((_vm.checkInList), function(checkIn, index) {
    return _c('div', {
      staticClass: "pitem"
    }, [_c('div', {
      staticClass: "left",
      on: {
        "click": function($event) {
          return _vm.edit(checkIn)
        }
      }
    }, [_c('img', {
      attrs: {
        "src": require("../../../static/user/headimg.png")
      }
    }), _vm._v(" "), _c('div', {
      staticClass: "msg"
    }, [_c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(checkIn.Name))]), _vm._v(" "), _c('div', {
      staticClass: "phone"
    }, [_vm._v("手机：" + _vm._s(checkIn.MobilePhone))])])]), _vm._v(" "), (_vm.fromMakeOrder != true) ? _c('div', {
      staticClass: "right"
    }, [_c('span', {
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.delHandler(checkIn.Id)
        }
      }
    }, [_vm._v("删除")])]) : _c('div', {
      staticClass: "right",
      on: {
        "click": function($event) {
          return _vm.choose(index)
        }
      }
    }, [(checkIn.selected) ? _c('img', {
      attrs: {
        "src": require("../../../static/user/InvoYes.png")
      }
    }) : _c('img', {
      attrs: {
        "src": require("../../../static/user/InvoNo.png")
      }
    })])])
  }), 0), _vm._v(" "), _c('loadListTail', {
    attrs: {
      "mainTitle": "您暂无常住信息",
      "mainIcon": "noDetail",
      "noMore": _vm.loadState.stop,
      "isLoading": _vm.loadState.loading,
      "overZero": _vm.checkInList.length > 0
    }
  }), _vm._v(" "), (_vm.loadState.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('img', {
    attrs: {
      "src": require("../../../static/LoadingBest.gif")
    }
  })]) : _vm._e(), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "dialogClass": "dia_passenger",
      "actionsContainerClass": "d_btns",
      "open": _vm.dialog,
      "title": "新增常住人",
      "titleClass": "d_title"
    },
    on: {
      "close": _vm.close
    }
  }, [_c('div', {
    staticClass: "u_item"
  }, [_c('label', [_vm._v("姓名")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.name),
      expression: "name"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入姓名"
    },
    domProps: {
      "value": (_vm.name)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.name = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u_item"
  }, [_c('label', [_vm._v("手机")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.phone),
      expression: "phone"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入手机号"
    },
    domProps: {
      "value": (_vm.phone)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.phone = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "u_item"
  }, [_c('label', [_vm._v("邮箱")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.email),
      expression: "email"
    }],
    attrs: {
      "type": "text",
      "placeholder": "请输入邮箱"
    },
    domProps: {
      "value": (_vm.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.email = $event.target.value
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "btns"
  }, [_c('mu-raised-button', {
    staticClass: "left",
    attrs: {
      "label": "取消"
    },
    on: {
      "click": _vm.close
    }
  }), _vm._v(" "), _c('mu-raised-button', {
    staticClass: "right",
    attrs: {
      "label": "确定"
    },
    on: {
      "click": _vm.InsertCheckIn
    }
  })], 1)]), _vm._v(" "), _c('mu-dialog', {
    attrs: {
      "open": _vm.hint,
      "title": ""
    },
    on: {
      "close": function($event) {
        _vm.hint = false
      }
    }
  }, [_c('div', {
    staticStyle: {
      "color": "#666666"
    }
  }, [_vm._v("\n        尊敬的客户，您确定删除该信息吗？\n      ")]), _vm._v(" "), _c('table', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('tr', [_c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flat-button', {
    staticStyle: {
      "background-color": "#cccccc",
      "color": "white"
    },
    attrs: {
      "slot": "actions",
      "primary": "",
      "label": "取消"
    },
    on: {
      "click": function($event) {
        _vm.hint = false
      }
    },
    slot: "actions"
  })], 1), _vm._v(" "), _c('td', {
    attrs: {
      "align": "center"
    }
  }, [_c('mu-flat-button', {
    staticStyle: {
      "background-color": "#27BA69",
      "color": "white"
    },
    attrs: {
      "slot": "actions",
      "label": "确定"
    },
    on: {
      "click": _vm.DeleteCheckIn
    },
    slot: "actions"
  })], 1)])])]), _vm._v(" "), (_vm.toast) ? _c('mu-toast', {
    attrs: {
      "id": "alertline",
      "message": _vm.hintMsg
    },
    on: {
      "close": _vm.hideToast
    }
  }) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-9a8a7ad0!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/user/PassengerMsg.vue
// module id = 1572
// module chunks = 18